import log from 'salvo-lite/log'

class PlusMinusInput {
    constructor (theme, elem) {
        this.elem = elem
        this.theme = theme
        this.plusButton = this.elem.querySelector('[data-plus]')
        this.minusButton = this.elem.querySelector('[data-minus]')
        this.input = this.elem.querySelector('[data-input]')
        this.min = 0
        this.max = Infinity
        log.debug(this.constructor.name, 'Constructed', this)
    }

    doLimits () {
        this.min = this.input.hasAttribute('min') ? parseInt(this.input.getAttribute('min')) : 1
        this.max = this.input.hasAttribute('max') ? parseInt(this.input.getAttribute('max')) : Infinity
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating', this)

        this.doLimits()

        this.minusButton.addEventListener('click', e => {
            this.doLimits()
            e.preventDefault()
            if ((parseInt(this.input.value) - 1) < this.min) {
                return false
            }
            this.input.value = parseInt(this.input.value) - 1
            this.input.dispatchEvent(new Event('input'))
        })

        this.plusButton.addEventListener('click', e => {
            this.doLimits()
            e.preventDefault()
            if ((parseInt(this.input.value) + 1) > this.max) {
                return false
            }
            this.input.value = parseInt(this.input.value) + 1
            this.input.dispatchEvent(new Event('input'))
        })

        this.input.addEventListener('input', e => {
            this.doLimits()
            if (parseInt(this.input.value) <= this.min) {
                this.value = this.min
            }
            if (parseInt(this.input.value) >= this.max) {
                this.value = this.max
            }
            if (isNaN(parseInt(this.input.value))) {
                this.value = this.min
            }
        })

        this.input.addEventListener('touchstart', e => {
            return false
        })

        log.debug(this.constructor.name, 'Initiated', this)
    }
}

export default PlusMinusInput



// WEBPACK FOOTER //
// ./src/resources/scripts/components/PlusMinusInput.js